export default function redirect(
  state = {
    path: "/",
  },
  action
) {
  switch (action.type) {
    case "SET_REDIRECT":
      return {
        ...state,
        path: action.payload,
      };

    case "CLEAR_REDIRECT":
      return {
        ...state,
        path: "/",
      };

    default:
      return state;
  }
}
